import { payNoMarketAddress } from 'src/app/models/pay-no-market-address.model';

export const LNRContracts = {
  registrar: '0x5564886ca2C518d1964E5FCea4f423b41Db9F561',
  nullResolver: payNoMarketAddress,
};
